import { render, staticRenderFns } from "./MassCustomerCategoryUploadCard.vue?vue&type=template&id=320eca96&scoped=true&"
import script from "./MassCustomerCategoryUploadCard.vue?vue&type=script&lang=js&"
export * from "./MassCustomerCategoryUploadCard.vue?vue&type=script&lang=js&"
import style0 from "./MassCustomerCategoryUploadCard.vue?vue&type=style&index=0&id=320eca96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320eca96",
  null
  
)

export default component.exports